import DisplayDesktop from "components/media-kit/static/display-desktop.png"
import SkinDesktop from "components/media-kit/static/skin-desktop.png"
import SbbanDesktop from "components/media-kit/static/sbban-desktop.png"
import WhiteroomDesktop from "components/media-kit/static/whiteroom-desktop.png"
import AlertDesktop from "components/media-kit/static/alert-desktop.png"
import ArticleDesktop from "components/media-kit/static/article-desktop.png"
import SocialDesktop from "components/media-kit/static/social-desktop.png"
import AppDesktop from "components/media-kit/static/app-desktop.png"

const ACTIVE_CLASS = "media-kit__item--active"
const SHOW_CLASS = "media-kit__show"
const desktopImg = document.querySelector(".media-kit__js-img-desktop")

const dict = {
  displaydesktop: DisplayDesktop,
  skindesktop: SkinDesktop,
  sbbandesktop: SbbanDesktop,
  whiteroomdesktop: WhiteroomDesktop,
  alertdesktop: AlertDesktop,
  articledesktop: ArticleDesktop,
  socialdesktop: SocialDesktop,
  appdesktop: AppDesktop,
}

export default function setListeners() {
  Array.from(document.querySelectorAll(".media-kit__item")).forEach((el) => {
    el.addEventListener("click", () => {
      Array.from(document.querySelectorAll(".media-kit__item")).forEach((item) => {
        if (item.classList.contains(`${ACTIVE_CLASS}`)) {
          item.classList.remove(`${ACTIVE_CLASS}`)
        }
      })
      desktopImg.src = dict[`${el.dataset.img}desktop`]

      Array.from(document.querySelectorAll(".media-kit__dimensions")).forEach((dimensionItem) => {
        if (dimensionItem.classList.contains(`${SHOW_CLASS}`)) {
          dimensionItem.classList.remove(`${SHOW_CLASS}`)
        }
      })
      document
        .querySelector(`.media-kit__dimensions--js-${el.dataset.img}`)
        .classList.add(`${SHOW_CLASS}`)

      el.classList.add(`${ACTIVE_CLASS}`)
    })
  })
}
